import * as React from "react";
import styled, { AnyStyledComponent, css, CSSObject } from 'styled-components'
import {ComponentType, RefAttributes} from 'react'
import { ThemeWithMediaQuery } from '../themes/mediaQuery'
import { Box } from './index'
import {BoxExtendedProps} from "grommet/components/Box";

export const withShowOnAndUp = (Component: AnyStyledComponent | ComponentType<any> | any, breakpoint: string | number) => styled(Component)`
  ${(props: any) => (props.defaultDisplay ? css({ display: props.defaultDisplay }) : '')}
  ${(props: any) => props.theme.mediaQuery.down(breakpoint)} {
    display: none;
  }
`

export const withHideOnAndDown = (Component: AnyStyledComponent | ComponentType<any> | any, breakpoint: string | number) => styled(Component)`
  ${(props: any) => (props.defaultDisplay ? css({ display: props.defaultDisplay }) : '')}
  ${(props: any) => props.theme.mediaQuery.up(breakpoint)} {
    display: none;
  }
`

export const ShowIfDesktop = withShowOnAndUp('div', 'tablet-landscape')
export const ShowIfNotDesktop = withHideOnAndDown('div', 'tablet-landscape')

export type MediaProps = Record<'large' | 'small' | 'medium', string | CSSObject> & {
    // tmp fix for TS compiler
    ref?: any
}
export const propsToMediaCss = (props: Partial<MediaProps> & { theme: ThemeWithMediaQuery }) => {
  const { mediaQuery } = props.theme
  return [Array.from<any>(mediaQuery.sizes().entries())
    .filter(([breakpoint]) => (props as any)[breakpoint])
    .map(([breakpoint]) => {
      const value = (props as any)[breakpoint]
      const method = (props as any)[`${breakpoint}-method`] || 'up'
      return css`${(mediaQuery as any)[method](breakpoint)} { ${value} }`
    })]
}

export const MediaBox = styled<React.FC<BoxExtendedProps & MediaProps & RefAttributes<any>>>(Box)`
  ${props => propsToMediaCss(props)}
`
